import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableRow,
  TextField,
  Typography,
  Grid,
  Box,
  FormControlLabel,
  InputLabel,
  FormControl,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { upperCase } from "lodash";
import React, { useState, useEffect } from "react";
import { useMessages } from "./MessagesContext";
import { createMessage, deleteMessage, saveMessage } from "./utils";
import MapClicker from "../../../components/MapClicker";
import RoomIcon from "@mui/icons-material/Room";

const MessageForm = () => {
  const [open, setOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [preview, setPreview] = useState("");
  const [linkPreviewUrl, setLinkPreviewUrl] = useState(null);
  const [mapClickerOpen, setMapClickerOpen] = useState(false);
  const {
    message,
    filterValues,
    selectedMessage,
    setSelectedMessage,
    setReload,
    setMessage,
  } = useMessages();

  useEffect(() => {
    setOpen(selectedMessage !== null || message !== null);
  }, [selectedMessage, message]);

  const handleChange = (e) => {
    const name = e.target.name.toLowerCase();
    const value = e.target.value;
    setMessage((prev) => ({ ...prev, [name]: value }));
  };

  const formValidate = (selectedMessage) => {
    let newFormErrors = {};
    if (selectedMessage.text === null || selectedMessage.text.trim() === "") {
      newFormErrors.text = "Please Enter Message Text";
      alert("Message field should not be empty");
    }
    if (!selectedMessage.priority) {
      newFormErrors.priority = "Select Priority Level";
      alert("Select Priority Level");
    }

    setFormErrors(newFormErrors);
    return Object.keys(newFormErrors).length === 0;
  };

  const saveMsg = (selectedMessage) => {
    if (formValidate(selectedMessage)) {
      if (selectedMessage.id === null)
        createMessage(selectedMessage).then(() => {
          setSelectedMessage(null);
          setMessage(null);
          setReload(true);
        });
      else
        saveMessage(selectedMessage).then(() => {
          setSelectedMessage(null);
          setMessage(null);
          setReload(true);
        });
    }
  };

  const deleteMsg = (selectedMessage) => {
    deleteMessage(selectedMessage).then(() => {
      setSelectedMessage(null);
      setMessage(null);
      setReload(true);
    });
  };

  const onClose = (e, reason) => {
    setSelectedMessage(null);
    setMessage(null);
    setFormErrors({});
    setPreview();
  };

  const handlePreview = (e) => {
    e.preventDefault();
    setPreview(message.text);
  };

  const title = message?.id ? "Edit Message" : "New Message";
  return (
    message && (
      <>
        <Dialog maxWidth="true" open={open} onClose={onClose}>
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              right: 10,
              top: 8,
            }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
          <Card sx={{ borderRadius: 3, overflow: "auto" }}>
            <CardHeader
              title={<font className="layer-title"> {title} </font>}
              align="center"
              className={"styledtablerow"}
            />
            <DescriptionBlock />
            <CardContent
              sx={{
                paddingTop: 1,
                paddingLeft: 0,
                paddingRight: 0,
                overflow: "auto",
              }}
            >
              <Box
                maxWidth="1000px"
                sx={{
                  paddingTop: 3,
                  paddingLeft: 2,
                  align: "center",
                  marginLeft: 5,
                }}
              >
                <Grid container spacing={{ xs: 1 }} sx={{ paddingLeft: 30 }}>
                  <Grid alignItems={"stretch"}>
                    <Table size="small">
                      <TableRow>
                        <TableCell className={"tablecellnoborder"}>
                          <TextField
                            disabled
                            size="small"
                            id="messageid"
                            label="ID"
                            value={message.id}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={"tablecellnoborder"}>
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                          >
                            <InputLabel id="message-Priority-label">
                              {" "}
                              Priority{" "}
                            </InputLabel>
                            <Select
                              labelId="message-Priority-label"
                              id="priority-selection"
                              value={message.priority}
                              label="Priority"
                              onChange={handleChange}
                              name="Priority"
                              error={formErrors.priority}
                              helperText={formErrors.priority}
                            >
                              {filterValues.priorities.map((eachpriority) => (
                                <MenuItem
                                  value={upperCase(eachpriority)}
                                  key={upperCase(eachpriority)}
                                >
                                  {upperCase(eachpriority)}{" "}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText>
                              {formErrors.priority}
                            </FormHelperText>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={"tablecellnoborder"}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={message.amberAlert}
                                  onChange={(e) => {
                                    setMessage((message) => {
                                      return {
                                        ...message,
                                        amberAlert: !message.amberAlert,
                                      };
                                    });
                                  }}
                                />
                              }
                              label="Amber Alert"
                            />
                          </FormGroup>
                        </TableCell>
                      </TableRow>
                    </Table>
                  </Grid>
                  <Grid xs={6}>
                    <Table size="small">
                      <TableRow>
                        <TableCell className={"tablecellnoborder"}>
                          <DateTimePicker
                            label="Created Date and Time"
                            value={message.creationDate}
                            onChange={(newValue) => {
                              setMessage((message) => {
                                return { ...message, creationDate: newValue };
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                error={false}
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={"tablecellnoborder"}>
                          <DateTimePicker
                            label="Start Date and Time"
                            value={message.startDate}
                            onChange={(newValue) => {
                              setMessage((message) => {
                                return { ...message, startDate: newValue };
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                error={false}
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={"tablecellnoborder"}>
                          <DateTimePicker
                            label="Expiration Date and Time"
                            value={message.expirationDate}
                            onChange={(newValue) => {
                              setMessage((message) => {
                                return { ...message, expirationDate: newValue };
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                error={false}
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                    </Table>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    paddingRight: 2,
                    pt: 0.5,
                    pb: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <TextField
                    size="small"
                    label="Latitude"
                    name="latitude"
                    value={message.latitude ?? ""}
                    onChange={handleChange}
                    sx={{ width: 160 }}
                    inputProps={{ step: "any" }}
                    type="number"
                  />
                  <TextField
                    size="small"
                    label="Longitude"
                    name="longitude"
                    value={message.longitude ?? ""}
                    onChange={handleChange}
                    sx={{ width: 160 }}
                    inputProps={{ step: "any" }}
                    type="number"
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<RoomIcon />}
                    onClick={() => setMapClickerOpen(true)}
                  >
                    Pick on Map
                  </Button>
                  <MapClicker
                    open={mapClickerOpen}
                    onClose={() => setMapClickerOpen(false)}
                    latitude={message.latitude}
                    longitude={message.longitude}
                    title="Pick Alert Location"
                    onLocationSelected={(lat, lng) => {
                      setMessage((prev) => ({
                        ...prev,
                        latitude: lat,
                        longitude: lng,
                      }));
                      setMapClickerOpen(false);
                    }}
                  />
                </Box>
                <Box sx={{ paddingRight: 2, pt: 1, pb: 1 }}>
                  <TextField
                    multiline
                    fullWidth
                    className={"tablecellnoborder"}
                    required
                    name="text"
                    id="filled-messagetext-flexible"
                    label="Message Text "
                    variant="filled"
                    type="text"
                    value={message.text}
                    onChange={handleChange}
                    error={formErrors.text}
                    helperText={formErrors.text}
                  />
                </Box>
                {preview && (
                  <Box mt={2} display={"flex"}>
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        padding: "10px",
                        width: "100%",
                      }}
                      onClick={(e) => {
                        if (e.target.tagName === "A") {
                          e.preventDefault();
                          setLinkPreviewUrl(e.target.href);
                        }
                      }}
                      dangerouslySetInnerHTML={{ __html: preview }}
                    />
                  </Box>
                )}
              </Box>
              <Box
                gap={2}
                display="flex"
                sx={{ p: 2, justifyContent: "center" }}
              >
                <Button
                  variant="outlined"
                  size="small"
                  type="button"
                  onClick={handlePreview}
                >
                  Preview Message
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => saveMsg(message)}
                >
                  Save Message
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => deleteMsg(message)}
                >
                  Delete Message
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Dialog>
        <Dialog
          fullScreen
          open={!!linkPreviewUrl}
          onClose={() => setLinkPreviewUrl(null)}
        >
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1,
                borderBottom: "1px solid #ccc",
              }}
            >
              <Typography variant="subtitle1" sx={{ flexGrow: 1, pl: 1 }}>
                Link Preview
              </Typography>
              <IconButton
                aria-label="close link preview"
                onClick={() => setLinkPreviewUrl(null)}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <iframe
                src={linkPreviewUrl || ""}
                title="Link Preview"
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            </Box>
          </Box>
        </Dialog>
      </>
    )
  );
};

const DescriptionBlock = () => {
  return (
    <Typography
      fontSize={13}
      component="div"
      sx={{ padding: 2, textAlign: "left" }}
    >
      <ul>
        <li>
          A title and some text are required for the Message, and an icon is
          required if there is a link.
        </li>
        <li>
          Enter the Expiration Date/Time in "mm/dd/yyyy hh:mm" format. For an
          Message with no Expiration Date/Time, clear that field.
        </li>
        <li>
          An Amber Alert message must be alert priority. Do not check the IDOT
          Amber Alert box for manually entered amber alert messages.
        </li>
        <li>
          Use complete sentences and correct punctuation. The message should be
          fewer than 35 words so that it fits in three lines in the page header.
        </li>
        <li>
          To link to page on Travel Midwest, use the style class "motdLink" and
          a title (popup text) as follows:
          <br />
          {
            '<a href="link URL" class="motdLink" title="popup text">link text</a>'
          }
        </li>
        <li>
          To link to another site, not Travel Midwest, use the "target"
          parameter so that it opens in a new window:
          <br />
          {
            '<a href="link URL" class="motdLink" target="_blank" title="popup text">link text</a>'
          }
        </li>
        <li>
          To link to an incident map, use the following syntax:
          <br />
          {
            '<a href="old_map.jsp?mapname=eventMap&id=id" class="motdLink">link text</a>'
          }
        </li>
        <li>
          Alternative method to link to incident map: You can go to the incident
          report, right click on the incident location, select "CopyLink
          Location" and then paste the provided URL in the MOTD.
        </li>
        <li>
          {
            "You can copy an <a>...</a> tag from one of these notes paste it into the Message Text."
          }
        </li>
      </ul>
    </Typography>
  );
};

export default MessageForm;
